import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { getEtatsLivreTranslated } from '../../utils/statusUtils';

const EtatLivreSelector = ({ control, name, disabled = false }) => {
  const { t } = useTranslation();
  const etatsLivre = getEtatsLivreTranslated(t);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl fullWidth margin="normal">
          <InputLabel>{t('bookCondition.label')}</InputLabel>
          <Select 
            {...field} 
            label={t('bookCondition.label')} 
            disabled={disabled}
            sx={{
              borderRadius: 2,
            }}
          >
            {etatsLivre.map((etat) => (
              <MenuItem key={etat.value} value={etat.value}>
                {etat.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
};

export default EtatLivreSelector;
